// extracted by mini-css-extract-plugin
export default {"CharacterPanel":"CharacterPanel_CharacterPanel__TmeQG"};